import Vue from 'vue';
import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import EdFileViewer from '@/content/components/ed-file-viewer/ed-file-viewer.vue';
import EdTextViewer from '@/content/pages/course-viewer/components/ed-text-viewer/ed-text-viewer.vue';
import EdVideoViewer from '@/content/pages/course-viewer/components/ed-video-viewer/ed-video-viewer.vue';
import EdLinkViewer from '@/content/pages/course-viewer/components/ed-link-viewer/ed-link-viewer.vue';
import EdImagesViewer from '@/content/pages/course-viewer/components/ed-images-viewer/ed-images-viewer.vue';
import EdSubdeckViewer from '@/courses/components/flash-cards/ed-subdeck-viewer/ed-subdeck-viewer.component.vue';
import EdPresentationModeHeader from '@/content/components/ed-presentation-mode/ed-presentation-mode-header/ed-presentation-mode-header.component.vue';
import EdViewerAudioObjectComponent from '@/courses/components/multimedia-objects/audio-object/ed-viewer-audio-object/ed-viewer-audio-object.component.vue';
import EdOtherFilesViewer from '@/content/pages/course-viewer/components/ed-other-files-viewer/ed-other-files-viewer.vue';
import EdPresentationModeTask from '@/content/components/ed-presentation-mode/ed-presentation-mode-task/ed-presentation-mode-task.component.vue';
import EdPresentationModeScroll from '@/content/components/ed-presentation-mode/ed-presentation-mode-tools/ed-presentation-mode-scroll';
import EdPresentationModeCursor from '@/content/components/ed-presentation-mode/ed-presentation-mode-tools/ed-presentation-mode-cursor';
import EdPresentationModeResize from '@/content/components/ed-presentation-mode/ed-presentation-mode-tools/ed-presentation-mode-resize';import { Section } from '@/courses/models/section.model';
import Course from '@/content/models/course.model';
import WebSocketMessageResponse from '@/content/models/web-socket-message-response.model';
import WebSocketMessageRequest from '@/content/models/web-socket-message-request.model';
import { HOMEWORKS_STORE } from '@/homework/store/homeworks.store';
import { _APP_STORE, CLOSE_BOARD_SOCKET_DISCONNECTING_EVENT, SHOW_SOCKET_DISCONNECTING_EVENT } from '@/core/values/app.values';
import { COURSE_MATERIAL_AUDIO_FILES_TYPES, COURSE_MATERIAL_VIDEO_FILES_TYPES } from '@/courses/values/courses.values';
import * as PRESENTATION_VALUES from '@/content/values/ed-presentation-mode.values';
import { SECTION_TYPES, TYPE_BOARD_DRAFT_RESPONSE_OPTIONS, TYPE_TEXT_DRAFT_RESPONSE_OPTIONS } from '@/content/values/sections';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import KEYS from '@/values/keys';
import { MEETING_EVENTS } from '@/meetings/values/meetings.values';
import { COURSE_EVENTS } from '@/content/values/events';
import { MESSAGE_EVENT } from '@/core/values/ed-transparency-meeting.values';
import EdPresentationModeFactory from '@/content/factories/ed-presentation-mode.factory';
import { CourseService } from '@/courses/services/courses.service';
import { BOARD_EVENTS } from '@/values/ed-whiteboard.values';
import { SECTION_TYPE_CODES, WBO_CURSOR_TYPES } from '@/core/values/ed-transparency-meeting.values';
import EdHtmlViewer from '@/components/common/ed-html-viewer/ed-html-viewer.vue';
import { IPresentationModeStatus, ITeacherSize } from '@/core/interfaces/presentation-mode-status.interface';
import EdScanImagesViewer from '../pages/course-viewer/components/ed-scan-images-viewer/ed-scan-images-viewer.component.vue';
import EdPresentationModeMixin from './ed-presentation-mode.mixin';

@Component({
  components: {
    EdFileViewer,
    EdTextViewer,
    EdVideoViewer,
    EdLinkViewer,
    EdImagesViewer,
    EdSubdeckViewer,
    EdViewerAudioObjectComponent,
    EdPresentationModeHeader,
    EdOtherFilesViewer,
    EdPresentationModeTask,
    EdScanImagesViewer,
    EdHtmlViewer,
  }
})
export default class PresentationModeViewerMixin extends Mixins(EdPresentationModeMixin) {

  @Prop() readonly roomId: number;
  @Prop() readonly classId: number;

  public courseId: number = 2;

  public internalSection: Section = null;
  public sectionMaterial: any = null;
  public isLoading: boolean = true;
  public courses: Course[] = [];
  public svgElement: HTMLElement = null;
  public currentSectionId: number = 0;
  public currentMaterialId: number = 0;
  public isInitialLoaded: boolean = false;
  public messageHigher: WebSocketMessageResponse = null;
  public isProcessInitialEventsLoaded: boolean = true;
  public isInitialResize: boolean = false;
  public processors: any = {
    Cursor: this.moveParentPointer,
    Scroll: this.moveScroll,
    Text: this.changeText,
    Layout: this.clickOverElement,
    Task: this.loadDocument,
    Video: this.changeStateVideo,
    Resize: this.changePageSize,
    Zoom: this.changePdfZoom,
    Whiteboard: this.showWhiteboard,
    Audio: this.changeAudioState,
    MultimediaVideo: this.changeMultimediaVideoState,
    ShareTask: this.showSharedTask,
    Slide: this.changeSlide,
    Card: this.changeCard
  };
  public componentStyle = {
    width: '700px',
    height: '1024px'
  }
  public basicMessages: string[] = [PRESENTATION_VALUES.EVENT_TYPES.resize, PRESENTATION_VALUES.EVENT_TYPES.task];
  public isTransparency: boolean = false;
  public isSharingTask : boolean = false;
  public isObtainInitialCourse : boolean = false;

  get presentationModeViewerType(){
    return this.$store.state.MeetingsStore.presentationModeViewerType == SECTION_TYPES.SUBDECK.code ? SECTION_TYPE_CODES.LESSON_CARD : this.$store.state.MeetingsStore.presentationModeViewerType;
  }

  get supportsPageSizeChange(): boolean {
    return this.internalSection === null || 
           this.internalSection.type === SECTION_TYPES.LESSON_TEXT.code || 
           this.internalSection.type === SECTION_TYPES.LESSON_IMAGES.code ||
           this.internalSection.type === SECTION_TYPES.SUBDECK.code ||
           this.internalSection.type === SECTION_TYPES.LESSON_SPLIT_WRITE.code ||
           this.internalSection.type === SECTION_TYPES.LESSON_SPLIT_TYPE.code;
  }

  get viewerLoad(): any {
    if (this.internalSection && this.validateBoardHomework(this.internalSection) && (this.isTransparency || this.isDraftResponseOption(this.internalSection))) {
      return PRESENTATION_VALUES.VIEWER_PRESENTATION_TASK;
    } else if (this.internalSection?.type === SECTION_TYPES.LESSON_MATERIAL.code) {
      this.$Meetings.Store.updatePresentationModeViewerType(SECTION_TYPES.LESSON_MATERIAL.code);
      return this.setCourseMaterialViewer();
    } else if (this.internalSection && this.internalSection.type !== KEYS.CONTENT_TYPE.BK) {
      this.updatePresentationModeViewerType(SECTION_TYPES[this.internalSection.type].code);
      return SECTION_TYPES[this.internalSection.type].viewer;
    } else {
      this.updatePresentationModeViewerType(SECTION_TYPES.LESSON_MATERIAL.code);
      return this.setCourseMaterialViewer();
    }
  }

  get viewerId() {
    let id = new Date().getTime();
    if (this.internalSection) {
      return `${this.internalSection.sectionId}${id}`;
    } else {
      return id;
    }
  }

  get pageSizeInfo(): any {
    return this.$store.state.MeetingsStore.presentationModePageSizeInfo;
  }

  get currentMeetingData() {
    return this.$store.state.MeetingsStore.currentMeetingData;
  }

  get isPresentationModeMeeting() {
    return (this.currentMeetingData.classId > 0 && this.currentMeetingData.meetingId > 0);
  }

  get homeworkSectionIsSent() : {[key: number]: boolean} {
    return this.$store.state.HomeworksStore.homeworkSectionIsSent;
  }

  get isBoardSectionHomework() {
    return this.$store.state.CourseStore.isBoardSectionHomework;
  }

  get whiteboardPath(): string {
    return this.$store.state.MeetingsStore.transparentBoardPath;
  }

  get isPreviousDisconnectionSocket(): boolean {
    return this.$store.state.AppStore.isPreviousDisconnectionSocket;
  }

  get isBoardPreviousDisconnectionSocket() : boolean {
    return this.$store.state.AppStore.isBoardPreviousDisconnectionSocket;
  }

  get isWebView(): boolean {
    return this.$store.state.AppStore.webview;
  }

  get presentationModeScrollInfo() {
    return this.$store.state.MeetingsStore.presentationModeScrollInfo;
  }

  get presentationModeLayoutInfo() {
    return this.$store.state.MeetingsStore.presentationModeLayoutInfo;
  }

  public setCourseMaterialViewer(): any {
    if (this.sectionMaterial && this.sectionMaterial.data && COURSE_MATERIAL_AUDIO_FILES_TYPES.includes(this.sectionMaterial.data.mimeType)) {
      return SECTION_TYPES.LESSON_MATERIAL.viewerAudioMaterial;
    }
    if (this.sectionMaterial && this.sectionMaterial.data && COURSE_MATERIAL_VIDEO_FILES_TYPES.includes(this.sectionMaterial.data.mimeType)) {
      return SECTION_TYPES.LESSON_MATERIAL.viewerVideoMaterial;
    }
    return SECTION_TYPES.LESSON_MATERIAL.viewer;
  }

  private updatePresentationModeViewerType(sectionType: string): void {
    this.$Meetings.Store.updatePresentationModeViewerType(sectionType);

    let multipleTypes: string[] = [];
    if (SECTION_TYPES.LESSON_SPLIT_TYPE.code === sectionType) {
      multipleTypes = [SECTION_TYPES.LESSON_PDF.code, SECTION_TYPES.LESSON_SPLIT_TYPE.code];
    }

    this.$Meetings.Store.updateMultiplePresentationModeViewerTypes(multipleTypes);
  }

  private isDraftResponseOption(section: Section): boolean {
    return (TYPE_BOARD_DRAFT_RESPONSE_OPTIONS.includes(section.type) || TYPE_TEXT_DRAFT_RESPONSE_OPTIONS.includes(section.type));
  }

  public validateBoardHomework(section : Section) : boolean{
    let isHomework : boolean = section.homework && this.isDraftResponseOption(section) &&
                                    this.currentBoardUser && Object.keys(this.currentBoardUser).length !== 0 && !this.currentBoardUser.isTeacher;
    this.$Courses.Store.setIsBoardSectionHomework(isHomework);
    return isHomework;
  }

  public validateBasicMessages() {
    let missingMessages: string[] = [];
    for (let type of this.basicMessages) {
      if (!this.messageHigher.messages[type]) {
        missingMessages.push(type);
      } else if (type === PRESENTATION_VALUES.EVENT_TYPES.resize) {
        let resizeData = JSON.parse(this.messageHigher.messages.Resize.content);
        if (!this.isResizeValid(resizeData)) {
          missingMessages.push(type);
        }
      }
    }

    if (missingMessages.length > 0) {
      let teacherUser: string = this.messageHigher.username;
      this.sendMissingMessages(missingMessages, teacherUser);
      return;
    }

    this.processBasicMessages();
  }

  public async processBasicMessages() {
    this.processInitialResize();

    if (this.messageHigher && this.messageHigher.messages && this.messageHigher.messages.Task && this.messageHigher.messages.Task.content) {
      let data = JSON.parse(this.messageHigher.messages.Task.content);
      this.isProcessInitialEventsLoaded = false;
      data.isInitial = true;
      await this.processors.Task(data);
    } else{

      setTimeout(() => {
        if(this.sectionMaterial === null && this.internalSection === null){
          this.showMessageNotDocument();
        }
      }, 500);
    }
  }

  public showMessageNotDocument(): void {
    this.$EdToast.create(
      {
        msg: `${this.$i18n.t('meetings.presentationMode.teacherNotSelectDocument')}`,
        type: TOAST_TYPES.INFO,
        top: '3rem'
      }
    );
  }

  public async loadPresentationElements(): Promise<void> {
    await this.createEventListeners();
    if (this.messageHigher) {
      this.processInitialEvents(this.messageHigher);
    }
  }

  public clearMessageHiger(isClearInitial: boolean) {
    if (isClearInitial && this.isProcessInitialEventsLoaded) {
      this.messageHigher = null;
      this.$Meetings.Store.updateInitialPresentationModeMessage(this.messageHigher);
    }
  }

  public loadAllMessages(message: WebSocketMessageResponse): void {
    if (message.messageType === PRESENTATION_VALUES.EVENT_TYPES.all) {
      this.loadInitialDocument(message);
    }

    if (message.messageType === PRESENTATION_VALUES.EVENT_TYPES.render) {
      let data = JSON.parse(message.content);
      if (!data.Resize && !this.messageHigher.messages.Resize) {
        return;
      }

      for (let key in data) {
        if (data[key]) {
          this.messageHigher.messages[key] = new WebSocketMessageResponse();
          this.messageHigher.messages[key].content = JSON.stringify(data[key]);
        }
      }

      this.processBasicMessages();
    }
  }

  //Implements for childs
  public async loadInitialDocument(data: WebSocketMessageResponse) : Promise<void> {
    return;
  }

  //Implements for childs
  public validateConnection(): void {
  }

  public restoreDefaultValues() : Promise<void> {
    return new Promise((resolve) => {
      this.showLoading();
      this.isInitialResize = false;
      this.isInitialLoaded = false;
      this.currentSectionId = 0;
      this.currentMaterialId = 0;
      this.sectionMaterial = null;
      this.internalSection = null;
      this.isTransparency = false;
      this.$Meetings.Store.updateWhiteboardTransparency(false);
      if (this.isPreviousDisconnectionSocket || this.isBoardPreviousDisconnectionSocket) {
        this.$EdModal.closeModal();
      }
      this.$App.Store.updatePreviousDisconnectionSocket(false);
      this.$App.Store.updateBoardPreviousDisconnectionSocket(false);
      resolve();
    });
  }

  public showErrorMessage(): void {
    this.$EdToast.create(
      {
        msg: `${this.$i18n.t('meetings.presentationMode.errorMessage')}`,
        type: TOAST_TYPES.WARNING,
        top: '3rem'
      }
    );
  }

  public transparencyEvents(event: any) : void {
    if (!this.whiteboardPath.includes(event.origin)){
      return;
    }
    if(event.data.isClick){
      this.$edEventBus.$emit(PRESENTATION_VALUES.CLOSE_MENU_TOOLS_EVENT);
    }
    if(event.data.isDisconnected !== undefined){
      this.manageTransparencyDisconnectMessage(event.data.isDisconnected);
    }
  }

  public async genericLeaveTeacherPresentation(): Promise<void> {
    await this.restoreDefaultValues();
    const message = this.isWebView ? 'leaveTeacherWebView' : 'leaveTeacher';
    this.$EdToast.create(
      {
        msg: `${this.$i18n.t('meetings.presentationMode.' + message)}`,
        type: TOAST_TYPES.WARNING,
        top: this.isWebView ? '0rem' : '3rem'
      }
    );

  }

  private sendMissingMessages(missingMessages: string[], teacherUser: string) {
    let data = JSON.stringify(missingMessages);
    let message: WebSocketMessageRequest = EdPresentationModeFactory.createWebSocketMessageRequest(PRESENTATION_VALUES.EVENT_TYPES.render,  String(this.roomId), false, data, teacherUser);
    this.$EdSocket.emit(PRESENTATION_VALUES.SOCKET_EVENTS.requestInformation, message);
  }

  private processInitialResize() {
    if (this.messageHigher && this.messageHigher.messages.Resize) {
      let resizeData = JSON.parse(this.messageHigher.messages.Resize.content);
      if (!this.isResizeValid(resizeData)) {
        return;
      }

      this.processors.Resize(resizeData);
      this.isInitialResize = true;
      delete this.messageHigher.messages.Resize;
    }
  }

  private isResizeValid(resizeData: any): boolean {
    let response: boolean = true;
    if (!resizeData.teacherWidth || !resizeData.teacherHeight) {
      response = false;
    }

    return response;
  }

  private async processInitialEvents(message: WebSocketMessageResponse) {
    if (message.messages.Layout) {
      let layoutData = JSON.parse(message.messages.Layout.content);
      await this.processors.Layout(layoutData);
    }

    if (message.messages.Zoom) {
      let zoomData = JSON.parse(message.messages.Zoom.content);
      this.changePdfZoom(zoomData);
    }

    if (message.messages.Scroll) {
      let scrollData = JSON.parse(message.messages.Scroll.content);
      this.processors.Scroll(scrollData);
    }


    if (message.messages.Video) {
      let videoData = JSON.parse(message.messages.Video.content);
      this.processors.Video(videoData);
    }

    if (message.messages.Whiteboard) {
      let whiteboardData = JSON.parse(message.messages.Whiteboard.content);
      this.processors.Whiteboard(whiteboardData);
    }

    if (message.messages.Audio) {
      let audioData = JSON.parse(message.messages.Audio.content);
      this.processors.Audio(audioData);
    }

    if (message.messages.MultimediaVideo) {
      let multimediaVideoData = JSON.parse(message.messages.MultimediaVideo.content);
      this.processors.MultimediaVideo(multimediaVideoData);
    }

    if(message.messages.ShareTask) {
      let sharedTaskData = JSON.parse(message.messages.ShareTask.content);
      this.processors.ShareTask(sharedTaskData);
    }

    if(message.messages.Slide) {
      let slideData = JSON.parse(message.messages.Slide.content);
      this.processors.Slide(slideData);
    }

    if(message.messages.Card) {
      let cardData = JSON.parse(message.messages.Card.content);
      this.processors.Card(cardData);
    }

    if (message.messages.Text) {
      const textData: any = JSON.parse(message.messages.Text.content);
      this.processors.Text(textData);
    }

    this.isProcessInitialEventsLoaded = true;
    this.clearMessageHiger(true);
  }

  private createEventListeners(): Promise<void> {
    let isBoardHomework : boolean = this.internalSection && this.isTransparency && this.isBoardSectionHomework;
    return EdPresentationModeScroll.createEventListeners(isBoardHomework);
  }

  private changePdfZoom(data: any) {
    if (!data || data.zoom === undefined) {
      return;
    }
    this.$Courses.Store.setZoomObject(data.zoom);
  }

  private loadDocument(data: any, isClearInitial: boolean = false): Promise<boolean> {
    if (!data.isInitial) {
      this.isProcessInitialEventsLoaded = true;
      this.clearMessageHiger(isClearInitial);
    }

    if (!(data && data.courseId && (data.sectionId || data.materialId) && data.title)) {
      return;
    }

    this.svgElement.style.setProperty('display', 'initial');
    this.$Meetings.Store.updateCurrentPresentationSection(data);
    this.$Meetings.Store.addCurrentPageSizes({});
    this.$Meetings.Store.updatePresentationModeScrollInfo({});
    this.$Meetings.Store.updatePresentationModeLayoutInfo({});
    this.$Meetings.Store.updateCurrentBoardUser({});
    this.$store.commit(HOMEWORKS_STORE.MUTATIONS.UPDATE_SELETED_BOARD_INFO, {});


    if (data.sectionId) {
      this.$store.commit(HOMEWORKS_STORE.MUTATIONS.UPDATE_HOMEWORK_SECTION_IS_SENT, {sectionId: data.sectionId, isSent: false});
      return this.loadSection(data);
    } else if (data.materialId) {
      this.$store.commit(HOMEWORKS_STORE.MUTATIONS.UPDATE_HOMEWORK_SECTION_IS_SENT);
      return this.loadMaterial(data);
    }
  }

  // Text type has a custom cursor
  private validateCursorPresentation(): void {
    if (SECTION_TYPES.LESSON_TEXT.code === this.internalSection?.type) {
      this.hideCursor(true);
    }
  }

  private loadSection(data: any): Promise<boolean> {
    return new Promise((resolve) => {
      if (data.sectionId === this.currentSectionId) {
        return resolve(true);
      }

      this.sectionMaterial = null;
      this.internalSection = null;
      this.mapCourse(data);
      this.currentSectionId = data.sectionId;
      this.currentMaterialId = 0;
      CourseService.obtainSectionInfo(data.courseId, data.sectionId, data.classId)
        .then(async response => {

          let section = {
            ...response,
            classId: data.classId,
            courseId: data.courseId,
            sectionId: data.sectionId,
          };

          section.sections.forEach((sectionChild) => {
            sectionChild.classid = data.classId; 
            sectionChild.courseId = data.courseId;
            sectionChild.sectionId = sectionChild.id;
          });

          await this.processCourseResponse(section);
          this.hideLoading();
          this.validateConnection();
          this.validateCursorPresentation();
          resolve(true);
        });
    });
  }

  private loadMaterial(data: any): Promise<boolean> {
    return new Promise((resolve) => {
      if (data.materialId === this.currentMaterialId) {
        return resolve(true);
      }

      this.sectionMaterial = null;
      this.internalSection = null;
      this.mapCourse(data);
      this.currentSectionId = 0;
      this.currentMaterialId = data.materialId;

      CourseService.obtainCourseMaterialInfo(data.courseId, data.materialId)
        .then(async response => {
          await this.processMaterialResponse(response);
          this.hideLoading();
          this.validateConnection();
          resolve(true);
        });
    });
  }

  private mapCourse(data: any): void {
    this.showLoading();
    let currentCourse = new Course({ id: data.courseId, title: data.title });
    this.courses.splice(0, 1, currentCourse);
    this.$Courses.Store.updatePresentationCourseSelected({
    presentationCourseSelected: data.courseId
  });
  }

  private processCourseResponse(response: any): Promise<void> {
    return new Promise((resolve) => {
      if (response.id !== this.currentSectionId) {
        return resolve();
      }
      this.internalSection = response;
      this.internalSection.homeworkInfo = null;
      if (response.sectionMaterial) {
        this.sectionMaterial = response.sectionMaterial;
        this.sectionMaterial.data = { ...response.sectionMaterial.materialAssetInfo };
      }
      resolve();
    });
  }


  private processMaterialResponse(response: any): Promise<void> {
    return new Promise((resolve) => {
      if (response.id !== this.currentMaterialId) {
        return resolve();
      }
      this.internalSection = new Section({ type: KEYS.CONTENT_TYPE.BK, text: KEYS.FILES_TYPE.PDF });
      this.internalSection.homeworkInfo = null;
      if (response.relatedContentResponse) {
        this.sectionMaterial = { materialId: response.id };
        this.sectionMaterial.data = { ...response.relatedContentResponse };
      }
      resolve();
    });
  }

  private async moveScroll(data: any, isClearInitial: boolean = true): Promise<void> {
    if(isClearInitial || Object.keys(this.presentationModeScrollInfo).length == 0) {
      this.$Meetings.Store.updatePresentationModeScrollInfo(data);
    }

    if((!this.currentBoardUser.isTeacher && this.isSharingTask && this.isBoardSectionHomework) || (!this.isSharingTask && this.isBoardSectionHomework)){
      return;
    }

    this.clearMessageHiger(isClearInitial);
    await EdPresentationModeScroll.moveScroll(data, this.isLoading);
    this.$edEventBus.$emit(MEETING_EVENTS.SCROLL_WHITEBOARD_TRANSPARENCY);
  }

  private clickOverElement(data: any, isClearInitial: boolean): Promise<boolean> {

    if(isClearInitial || Object.keys(this.presentationModeLayoutInfo).length == 0) {
      this.$Meetings.Store.updatePresentationModeLayoutInfo(data);
    }
    
    this.clearMessageHiger(isClearInitial);
    return new Promise((resolve) => {
      if (this.isLoading) {
        return resolve(true);
      }

      if (data.layout) {
        this.changeLayout(data.layout);
      }
      Vue.nextTick().then(() => {
        this.changeLayout(data.tab)
        resolve(true);
      });
    });
  }

  private changeLayout(elementId: string) {
    if (!elementId) {
      return;
    }
    let specificElement = document.getElementById(elementId);

    specificElement?.click();
    setTimeout(this.hideTypeResponseScroll, 1000);
    this.$edEventBus.$emit(MEETING_EVENTS.RESIZE_WHITEBOARD_TRANSPARENCY);
  }

  private hideTypeResponseScroll(): void {
    EdPresentationModeScroll.hideTypeResponseScroll();
  }

  private moveParentPointer(data: any): Promise<boolean> {
    data.teacherHeight = this.pageSizeInfo.teacherHeight;
    data.teacherWidth = this.pageSizeInfo.teacherWidth;
    data.zoomObject = this.zoomObject;
    data.isTransparency = this.isTransparency;
    return EdPresentationModeCursor.moveParentPointer(data, this.isLoading, this.svgElement);
  }

  private changeStateVideo(data: any): void {
    if (data !== null) {
      this.$edEventBus.$emit(COURSE_EVENTS.UPDATE_STATE_VIDEO, data);
    }
  }

  private changeAudioState(data: any): void {
    if (data !== null) {
      this.$edEventBus.$emit(COURSE_EVENTS.UPDATE_AUDIO_STATE, data);
    }
  }

  private changeMultimediaVideoState(data: any): void {
    if (data !== null) {
      this.$edEventBus.$emit(COURSE_EVENTS.UPDATE_MULTIMEDIA_VIDEO_STATE, data);
    }
  }

  private async changeSlide(data: any): Promise<void> {
    if (data !== null) {
      this.$edEventBus.$emit(COURSE_EVENTS.CHANGE_SLIDE, data);
    }
  }

  private emitChangePresentationTaskUserEvent(): void {
    if(!document.querySelectorAll('.ed-presentation-mode-task')[0]) {
      setTimeout(() => {
        this.emitChangePresentationTaskUserEvent();
      }, 500);
    } else {
      this.$edEventBus.$emit(PRESENTATION_VALUES.CHANGE_PRESENTATION_TASK_USER_EVENT);
    }
  }

  private showSharedTask(sharedData: any): void {
    const userData: { [key: string]: any } = {
      id: this.user.id,
      sectionId: this.currentSectionId,
      fullName: this.user.fullName,
      isTeacher: false,
      active: sharedData.active
    };
    if (!sharedData.active && !this.isSharingTask) {
      if (!this.currentBoardUser || (this.currentBoardUser.id !== userData.id)) {
        this.$Meetings.Store.updateCurrentBoardUser(userData);
        this.emitChangePresentationTaskUserEvent();
      }
      return;
    }
    let isSameUser: boolean = this.currentBoardUser.id === sharedData.userId;
    let isPreviousTeacher: boolean = this.currentBoardUser.isTeacher && this.user.id === sharedData.userId;
    if ((isSameUser || (!isSameUser && !sharedData.active)) && this.currentBoardUser.isTeacher && this.homeworkSectionIsSent[this.currentSectionId]) {
      return;
    }
    let selectedBoardInfo: { [key: string]: any } = {};
    if (sharedData.active) {
      userData.id = sharedData.userId;
      userData.fullName = sharedData.fullName;
      userData.isTeacher = sharedData.isTeacher;
      userData.sectionId = sharedData.sectionId;

      if (!sharedData.isTeacher) {
        selectedBoardInfo.boardGroupHash = sharedData.boardGroupHash;
        selectedBoardInfo.numberPages = sharedData.numberPages;
        selectedBoardInfo.homeworkId = sharedData.homeworkId;
      }
    } else {
      this.showNotSharedInfoMessage();
    }
    this.$store.commit(HOMEWORKS_STORE.MUTATIONS.UPDATE_SELETED_BOARD_INFO, selectedBoardInfo);
    this.$Meetings.Store.updateCurrentBoardUser(userData);
    this.$nextTick(() => {
      if (((sharedData.userId !== this.user.id && this.isSharingTask && !sharedData.active)
        || (sharedData.active && !isSameUser)) && !sharedData.isTeacher && !isPreviousTeacher) {
        this.emitChangePresentationTaskUserEvent();
      }
      this.isSharingTask = sharedData.active;
    });
  }

  private changePageSize(size: ITeacherSize) {
    if (!this.supportsPageSizeChange) {
      return;
    }

    let pageSizeInfo = EdPresentationModeResize.changePageSize(size);
    this.componentStyle.width = pageSizeInfo.width;
    this.componentStyle.height = pageSizeInfo.height;

    this.$Meetings.Store.updatePresentationModePageSizeInfo(pageSizeInfo);
    this.$edEventBus.$emit(MEETING_EVENTS.RESIZE_WHITEBOARD_TRANSPARENCY);
                                    
  }

  private showWhiteboard(data: any) {
    if (!this.isPresentationModeMeeting) {
      return;
    }
    this.isTransparency = data.isTransparency;
    this.hideCursor(this.isTransparency || WBO_CURSOR_TYPES.includes(this.presentationModeViewerType));
    this.$Meetings.Store.updateWhiteboardTransparency(data.isTransparency);
  }

  private hideCursor(isHide: boolean): void {
    let displayValue: string = isHide ? 'none' : 'initial';
    this.svgElement.style.setProperty('display', displayValue);
  }

  public async refreshStatus(presentationModeStatus: IPresentationModeStatus){
      if(presentationModeStatus.selectedObject)
        this.loadDocument(presentationModeStatus.selectedObject);
      if(presentationModeStatus.shareTask)
        this.showSharedTask(presentationModeStatus.shareTask);
      if(presentationModeStatus.size)
        this.changePageSize(presentationModeStatus.size);
      if(presentationModeStatus.scroll)
        this.moveScroll(presentationModeStatus.scroll, true);
      if(presentationModeStatus.layout)
        this.clickOverElement(presentationModeStatus.layout, true);
      if(presentationModeStatus.video)
        this.changeStateVideo(presentationModeStatus.video);
      if(presentationModeStatus.multimediaVideo)
        this.changeMultimediaVideoState(JSON.stringify(presentationModeStatus.multimediaVideo));
      if(presentationModeStatus.audio)
        this.changeAudioState(JSON.stringify(presentationModeStatus.audio));
      if(presentationModeStatus.card)
        this.changeCard(presentationModeStatus.card)
      if(presentationModeStatus.slide)
        this.changeSlide(presentationModeStatus.slide)
      //ELementSize??
      this.changePdfZoom({zoom: presentationModeStatus.zoom})
      this.showWhiteboard({isTransparency: presentationModeStatus.transparency})
  }

  private manageTransparencyDisconnectMessage(isDisconnected : boolean){
    if(isDisconnected){
      this.$edEventBus.$emit(SHOW_SOCKET_DISCONNECTING_EVENT, {isBoard: true});
    } else if(!isDisconnected && this.isBoardPreviousDisconnectionSocket){
      this.$edEventBus.$emit(CLOSE_BOARD_SOCKET_DISCONNECTING_EVENT);
    }
  }

  private showLoading(): void {
    this.isLoading = true;
  }

  private hideLoading(): void {
    this.isLoading = false;
  }

  private showNotSharedInfoMessage(): void {
    this.$EdToast.create(
      {
        msg: `${this.$i18n.t('meetings.presentationMode.teacherStoppedSharing')}`,
        type: TOAST_TYPES.WARNING,
        top: '3rem',
        timeout: 3000
      }
    );
  }

  private changeCard(data: any) {
    this.$edEventBus.$emit(COURSE_EVENTS.CHANGE_CARD_SIDE, data);
    this.$Courses.Store.setCurrentCardInfo(data);
  }

  private changeText(data: any): void {
    this.$edEventBus.$emit(COURSE_EVENTS.TEXT_CHANGED, data)
  }

  mounted() {
    this.validateConnection();
    this.svgElement = document.getElementById(PRESENTATION_VALUES.ELEMENT_IDS.CURSOR_CONTAINER);
    this.$Courses.Store.setPresentationStudentMode({ isPresentationStudentMode: true });
    this.$edEventBus.$on(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.LOAD_PRESENTATION_ELEMENTS, this.loadPresentationElements);
    this.$edEventBus.$on(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.LOAD_ALL_MESSAGES, this.loadAllMessages);
    this.$edEventBus.$on(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.REFRESH_SATUS, this.refreshStatus);
    this.$edEventBus.$on(BOARD_EVENTS.STUDENT_INITIAL_BOARDS_LOADED, this.moveScroll);
    this.$edEventBus.$on(BOARD_EVENTS.UPDATE_LAYOUT, this.clickOverElement);
    window.addEventListener(MESSAGE_EVENT, this.transparencyEvents, false);
  }

  beforeDestroy() {
    this.$Courses.Store.setZoomObject(true);
    this.$Courses.Store.setPresentationStudentMode({ isPresentationStudentMode: false });
    this.$Courses.Store.setIsBoardSectionHomework(false);
    this.$Meetings.Store.updateCurrentBoardUser({});
    this.$Meetings.Store.updateTransparentBoardPath('');
    this.$Meetings.Store.updateCurrentPresentationSection({});
    this.$store.commit(HOMEWORKS_STORE.MUTATIONS.CLEAR_PRESENTATION_SECTION_CONTENT);
    this.$store.commit(HOMEWORKS_STORE.MUTATIONS.UPDATE_SELETED_BOARD_INFO, {});
    this.$store.commit(HOMEWORKS_STORE.MUTATIONS.UPDATE_HOMEWORK_SECTION_IS_SENT);
    this.$edEventBus.$off(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.LOAD_PRESENTATION_ELEMENTS, this.loadPresentationElements);
    this.$edEventBus.$off(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.LOAD_ALL_MESSAGES, this.loadAllMessages);
    this.$edEventBus.$off(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.REFRESH_SATUS, this.refreshStatus);
    this.$edEventBus.$off(BOARD_EVENTS.STUDENT_INITIAL_BOARDS_LOADED, this.moveScroll);
    this.$edEventBus.$off(BOARD_EVENTS.UPDATE_LAYOUT, this.clickOverElement);
    window.removeEventListener(MESSAGE_EVENT, this.transparencyEvents, false);
    this.$EdToast.hide();
  }
}
